import styled from 'styled-components';

export const CategoryBreadcrumbs = styled.div`
  background-color: #fff;
  text-transform: uppercase;
  ul {
    height: 40px;
    padding: 0px;
    display: flex;
    align-items: center;
    width: 100%;
    @media (max-width: 720px) {
      max-width: 100%;
      padding: ${(props) => (props.noPad ? '0' : '0 10px')};
    }
    @media (min-width: 720px) {
      column-gap: 7px;
    }
    overflow: auto;
    &::-webkit-scrollbar {
      display: none !important;
    }
  }
  &.addClass {
    @media (min-width: 720px) {
      max-width: ${(props) => (props.location == 'category' ? '80%' : '85%')};
      margin: 0 auto;
    }
  }
`;

export const BreadcrumbsList = styled.li`
  font-size: 11px;
  color: rgb(0 0 0 / 40%);
  font-weight: 500;
  &.current {
    cursor: default;
  }
  @media (min-width: 720px) {
    column-gap: 21px;
  }

  &.greenColor {
    color: #4b9d9b;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    white-space: nowrap;

    &:hover {
      text-decoration: underline;
    }

    @media (max-width: 720px) {
      cursor: default;
    }
  }

  &:nth-last-child(1) {
    width: 30%;
    white-space: nowrap;
    text-overflow: ellipsis;
    pointer-events: none;
    cursor: not-allowed;

    @media (max-width: 720px) {
      width: 100%;
    }
  }
`;

// Add this new styled component to your styled.js file
export const BreadcrumbsHeading = styled.h2`
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  margin: 0;
  display: inline-flex;
  align-items: center;
  white-space: inherit;
  text-overflow: inherit;
  width: 100%;
`;

export const BreadCrumbsArrow = styled.img`
  width: 10px;
  height: 10px;
  opacity: 0.4;
  transform: rotate(270deg);
  margin: 0 6px;

  &.hideArrow {
    display: none;
  }
`;
export const BreadCrumbsArrowSvg = styled.span`
  svg {
    width: 10px;
    height: 10px;
    opacity: 0.4;
    transform: rotate(270deg);
    margin: 0 6px;
  }
  &.hideArrow {
    display: none;
  }
`;
